var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_calendar",
    clipPath: "url(#clip-icon_calendar)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605",
    transform: "translate(-146.659 -178.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2056",
    "data-name": "Rectangle 2056",
    d: "M0-.5H17.427a.5.5,0,0,1,.5.5V13.155a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM16.927.5H.5V12.655H16.927Z",
    transform: "translate(149.928 184.476)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2057",
    "data-name": "Rectangle 2057",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(149.964 188.918)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(154.321 188.918)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(158.677 188.918)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2060",
    "data-name": "Rectangle 2060",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(163.034 188.918)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(149.964 193.275)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2062",
    "data-name": "Rectangle 2062",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(154.321 193.275)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2063",
    "data-name": "Rectangle 2063",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(158.677 193.275)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2064",
    "data-name": "Rectangle 2064",
    d: "M0-.5H4.357a.5.5,0,0,1,.5.5V4.357a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM3.857.5H.5V3.857H3.857Z",
    transform: "translate(163.034 193.275)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    "data-name": "Line 11",
    d: "M0,2.982a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.482A.5.5,0,0,1,0,2.982Z",
    transform: "translate(154.321 183.191)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_12",
    "data-name": "Line 12",
    d: "M0,2.982a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.482A.5.5,0,0,1,0,2.982Z",
    transform: "translate(158.641 183.191)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_13",
    "data-name": "Line 13",
    d: "M0,2.982a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.482A.5.5,0,0,1,0,2.982Z",
    transform: "translate(162.962 183.191)",
    fill: "#377ef3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.b245f4d3d6c87973d5b38fbe093cef5d.svg";
export { ForwardRef as ReactComponent };